import { Button, Dialog, DialogActions, DialogTitle, Snackbar } from '@material-ui/core';
import React, { useState } from 'react';
import { useMutation, queryCache } from 'react-query';
import { useAuth } from '../../../../../auth/authProvider';
import partnershipRequest from '../../../../../services/network/partnershipRequest';

export const ExcluirInvoicePaymentDialog = props => {
  const { show, onClose, data, refetchInvoices } = props;
  const { token } = useAuth();
  const [alert, setAlert] = useState({ show: false, msg: '' });

  const [excluirInvoicePayment] = useMutation(
    () => partnershipRequest.delete(`invoices/partner-invoice-comissioning-lead/${data?.paymentId}`, { token }),
    {
      onSuccess: () => {
        setAlert({ show: true, msg: 'Comissão excluída' });
        onClose();
        queryCache.refetchQueries('fetch-payments');
        if (refetchInvoices) {
          refetchInvoices();
        }
      },
      onError: error => {
        setAlert({ show: true, msg: error.message || 'Erro ao desvincular' });
      },
    },
  );

  return (
    <>
      <Dialog open={show} onClose={onClose}>
        <DialogTitle>Deseja realmente excluir essa comissão?</DialogTitle>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            CANCELAR
          </Button>
          <Button color="primary" onClick={excluirInvoicePayment}>
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert.show}
        autoHideDuration={6000}
        message={alert.msg}
        onClose={() => setAlert({ show: false, msg: '' })}
      />
    </>
  );
};
